import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { Box, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AIIndicatorTooltipPrimitive = styled(TooltipPrimitive)({
  borderRadius: "var(--ds-border-radius, 3px)",
  backgroundColor: "var(--ds-surface-raised, white)",
  boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))",
  boxSizing: 'content-box',
  padding: "var(--ds-space-200, 16px)",
  maxWidth: '350px'
});
const triggerStyles = xcss({
  display: 'inline-flex'
});
const AIIndicatorTooltip = ({
  content,
  trigger,
  xcss: overrideXcss
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    component: AIIndicatorTooltipPrimitive,
    content: content,
    tag: "span"
  }, tooltipProps => /*#__PURE__*/React.createElement(Box, _extends({
    xcss: [triggerStyles, overrideXcss]
  }, tooltipProps), trigger));
};
export default AIIndicatorTooltip;